import { useIntl } from 'react-intl';
import Image from '@alltrails/core/components/Image';
import { useLanguageRegionCode } from '@alltrails/core/hooks/useLanguageRegionCode';
import { appleEditorsChoiceImages } from '../AppPromotion';

type AppleEditorsChoiceProps = {
  width?: number;
  height?: number;
  className?: string;
};

const AppleEditorsChoice = ({ width = 140, height = 37, className }: AppleEditorsChoiceProps) => {
  const intl = useIntl();
  const languageRegionCode = useLanguageRegionCode();
  const src = appleEditorsChoiceImages[languageRegionCode];

  return (
    <Image
      alt={intl.formatMessage({ defaultMessage: "Apple App Store Editors' Choice" })}
      className={className}
      height={height}
      src={src}
      width={width}
      loading="lazy"
    />
  );
};

export default AppleEditorsChoice;
